import { Component } from '@angular/core';
import { Menu } from '@maced/angular-components/lib/navigation-drawer/menubar/menubar.model';

@Component({
  selector: 'app-menubar',
  templateUrl: './menubar.component.html'
})
export class MenubarComponent {
  closeUrl = "/button";
  menuList: Menu[] = [
    { id: "Menubar", name: "Menubar", icon: "icon-bookshelf", trailingIcon: 'icon-chevron-right', url: '/menubar', queryParams: { test: 'test' } },
    { id: "Quick Links", name: "Quick Links", icon: "icon-cursor-click", trailingIcon: 'icon-chevron-right', url: "/card", queryParams: { test2: 'test2' } },
    { id: "My Bookmarks", name: "My Bookmarks", icon: "icon-bookmark", trailingIcon: 'icon-chevron-right', url: "/card", queryParams: { test2: 'test2' } },
    { id: "My Notes", name: "My Notes", icon: "icon-notes", trailingIcon: 'icon-chevron-right', url: "/modal-header" },
    { id: "Extra Activities", name: "Extra Activities", icon: "icon-file-plus", trailingIcon: 'icon-chevron-right', url: "/button" },
    { id: "All Activities", name: "All Activities", icon: "icon-file-plus", trailingIcon: 'icon-chevron-right', url: "/navbar" },
    { id: "My Downloads", name: "My Downloads", icon: "icon-download", trailingIcon: 'icon-chevron-right', url: "/card" },
    { id: "Read Aloud", name: "Read Aloud", icon: "icon-volume-max", trailingIcon: 'icon-chevron-right', url: "/button" }
  ];
}